export const POSTBATTLE_TABS_LIST = ['result', 'details']

export const POSTBATTLE_MAX_ROWS = 4
export const POSTBATTLE_ROW_HEIGHT = 59
export const POSTBATTLE_HEADER_HEIGHT = 318



// WEBPACK FOOTER //
// ./containers/PostbattleScreen/constants.jsx